import React, { useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';
import { InputLabel, InputTextArea } from '@bb/elements-web';
import { set } from 'lodash';
import { AccessOptionProps } from '../../types';
import MasterlockValidator from '../../../AccessValidators/MasterlockValidator';
import UploadEditPhotoButton from '../UploadEditPhotoButton';

const Masterlock: React.FC<AccessOptionProps> = ({
  listing,
  showingsConfig,
  setShowingsConfig,
  setIsValid,
}) => {
  const [isMasterLockCodeValid, setIsMasterLockCodeValid] = useState(false);
  const [shouldGetLockboxes, setGetLockboxesFalse] = useReducer(
    () => false,
    true,
  );
  const resetAppointmentConfigAccess = () =>
    setShowingsConfig(prev => ({ ...prev, access: '' }));

  const setIsMasterLockOneDayCodeEnabled = (enabled: boolean) =>
    setShowingsConfig(prev =>
      set(prev, 'instructions.masterlock.isOneDayCodeEnabled', enabled),
    );
  const onMasterLockValidate = (deviceId: string | null = null) =>
    setShowingsConfig(prev =>
      set(prev, 'instructions.masterlock.deviceId', deviceId),
    );

  useEffect(() => {
    setIsValid(isMasterLockCodeValid);
  }, [setIsValid, showingsConfig, isMasterLockCodeValid]);

  return (
    <>
      <StyledMasterlockValidatorWrapper $isValid={isMasterLockCodeValid}>
        <InputLabel label="Select Lockbox" required />
        <MasterlockValidator
          resetAppointmentConfigAccess={resetAppointmentConfigAccess}
          setIsMasterLockCodeValid={setIsMasterLockCodeValid}
          setIsMasterLockOneDayCodeEnabled={setIsMasterLockOneDayCodeEnabled}
          setGetLockboxesFalse={setGetLockboxesFalse}
          onValidate={onMasterLockValidate}
          shouldGetLockboxes={shouldGetLockboxes}
          listingId={listing.id.toString()}
          deviceId={showingsConfig.instructions.masterlock?.deviceId || ''}
          instructions={showingsConfig.instructions.masterlock}
        />
      </StyledMasterlockValidatorWrapper>
      <UploadEditPhotoButton
        listingId={listing.id}
        lockboxPhoto={showingsConfig.lockboxPhoto}
        setLockboxPhoto={val => {
          setShowingsConfig(prev => ({
            ...prev,
            lockboxPhoto: val,
          }));
        }}
      />
      <div>
        <InputTextArea
          label="Other Masterlock instructions"
          labelExtra="(optional)"
          dataCy="showing-notification-masterlock-instructions"
          value={showingsConfig.instructions.masterlock?.details || ''}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                masterlock: {
                  deviceId: '',
                  ...(prev.instructions.masterlock || {}),
                  details: value,
                },
              },
            }))
          }
        />
      </div>
    </>
  );
};

const StyledMasterlockValidatorWrapper = styled.div<{ $isValid: boolean }>`
  .masterlock-validator-add-lockbox-link {
    ${({ $isValid }) => (!$isValid ? 'color: red;' : '')}
  }
`;

export default Masterlock;
